import { AbstractControl, ValidationErrors } from "@angular/forms";
export class CustomValidators {
  static pastDateValidator(
    control: AbstractControl,
    isEditMode: boolean = false
  ): ValidationErrors | null {
    if (isEditMode) return null;

    const selectedDate = new Date(control.value);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return selectedDate < today ? { pastDate: true } : null;
  }

  static dateAfterValidator(fromField: string) {
    return (control: AbstractControl): ValidationErrors | null => {
      const fromDate = control.parent?.get(fromField)?.value;
      if (!fromDate || !control.value) return null;
      return new Date(control.value) < new Date(fromDate)
        ? { beforeFromDate: true }
        : null;
    };
  }

  static timeAfterValidator(fromField: string) {
    return (control: AbstractControl): ValidationErrors | null => {
      const fromTime = control.parent?.get(fromField)?.value;
      if (!fromTime || !control.value) return null;
      return control.value <= fromTime ? { beforeCheckIn: true } : null;
    };
  }
}
